// 引入axios用来封装http请求
import axios, { AxiosRequestConfig } from "axios";
import Vue from "vue";
// token失效|禁用跳转登录页
import router from "../router/index";
import { innerLock } from "@/utils/lock";
import { LSKeys } from "@/constants/Key";
import { postRefresh } from "@/constants/api/LOGIN_API";
import throttle from "lodash.throttle";
import { showToast } from "@/utils/ding";
import { creatUuid } from "@/utils/creatuuid";
// 提示信息常量引入，方便统一更改
import {
  HTTP_STATUS_MSG_401,
  HTTP_STATUS_MSG_5XX,
  HTTP_STATUS_TITLE_ERROR,
  HTTP_STATUS_TITLE_5XX,
} from "@/constants/TEXT";
import { stopLoading } from "@/mixin/loading";
// Content-Type:application/x-www-form-urlencoded时 对json数据字符串处理，JSON.stringify()不是很理想
import qs from "qs";
// 引入element-ui右侧弹框提示样式，可以根据项目需求改不同形式弹框
import { Notification } from "element-ui";
import { locale } from "@/locale";
import {
  COMMON_FUTURE_MAP_URL,
  // PATH_ZHIYINLOU,
  PATH_HOME,
  // PATH_YACH_TAB,
  PATH_OKR_AUTHORIZATION,
  PATH_WEEKLY_AUTHORIZATION,
} from "@/constants/URL";
const querys = qs.parse(window.location.search, {
  ignoreQueryPrefix: true,
});
const postHeaders = "application/json";
// 创建axios实例常量配置
const axiosCreate = {
  // 根据环境配置后端api的url
  // baseURL: process.env.VUE_APP_API_URL,
  // 请求超时时间
  timeout: 30000,
  // 是否允许后端设置cookie跨域，一般无需改动
  withCredentials: true,
  validateStatus: function (status: number) {
    // 若状态码大于等于400时则Reject 用来统一处理5XX报错走catch方法
    return status < 400;
  },
};

/**
 * 设置post方法的Content-Type
 * 根据后端要求进行application/x-www-form-urlencoded和application/json的替换。
 * 默认application/x-www-form-urlencoded
 * 若是application/json传递，则不需要qs字符串化
 */
// const postHeaders = "application/x-www-form-urlencoded";

// 创建axios实例
const http = axios.create(axiosCreate);
http.defaults.headers.common["Content-Type"] = postHeaders;
http.defaults.withCredentials = true;
// let loadingInstance: any

let refreshing = false;
const refreshErr = new Error("refreshing token");
const tokenRefreshDuration = 5000;
let systemTage = 0;

function tokenCheck(config: AxiosRequestConfig) {
  const url = config.url;
  //* login 页面的请求不检查
  const isLoginReq = url && url.includes("/login");
  if (isLoginReq) return;
  //* token剩余时间少于 600s 就触发刷新token接口

  if (
    // Vue.$ls.ttl(LSKeys.userToken) != -1 &&
    // Vue.$ls.ttl(LSKeys.userToken) < 3570000
    Vue.$ls.ttl(LSKeys.userToken) != -1 &&
    Vue.$ls.ttl(LSKeys.userToken) < 600000
  ) {
    postRefresh()
      .then((res) => {
        // console.log(process.env.VUE_APP_WORKCODE, "res1111",res)
        Vue.$ls.set(LSKeys.userToken, res.token, res.expires * 1000);
        refreshing = false;
      })
      .catch((e) => {
        // console.log("catch",e)
      });
    refreshing = true;
  }
}
const throttleCheck = throttle(tokenCheck, tokenRefreshDuration);
/**
 * axios request拦截器
 * 要求后端不管成功与否返回数据结构
 * {
 *  data:{    正常来讲就是返回数据
 *   errcode:'1'/'2'/'3'...    极少数errcode用来拓展业务需求特殊处理的情况，结合业务需求前后端协商定义
 *  },
 *  errmsg:'失败后端提示信息'       若http状态码为444，我就弹出errmsg内容
 * }
 */
http.interceptors.request.use(
  (config: any) => {
    let platform = (window as any).yach.platform;

    if (platform !== "notInYach") {
      platform = "3";
    } else if ((window as any).dd && (window as any).dd.pc) {
      platform = "1";
    } else {
      platform = "3";
    }
    systemTage = platform;
    config.params = {
      ...config.params,
      platform,
    };
    //* 正在刷新token, 不拦截刷新api本身,其他请求延迟请求
    if (refreshing && !config["url"].includes("/api/refresh")) {
      setTimeout(function () {
        http(config);
      }, 500);
      throw refreshErr;
    }
    // loadingInstance = Loading.service({ fullscreen: true });
    //* 非登录接口 的时候判断token过期时间,进行刷新
    // throttleCheck(config);
    //! 处理 ios9上的bug
    if (config["url"].includes("/talent")) {
      // 如果是从未来人才跳转
      config.headers["Authorization"] = "Bearer " + Vue.$ls.get("talentToken");
    } else {
      //* 非登录接口 的时候判断token过期时间,进行刷新
      // throttleCheck(config);
      config.headers["Authorization"] = Vue.$ls.get(LSKeys.userToken, "")
        ? "Bearer " + Vue.$ls.get(LSKeys.userToken, "")
        : "Bearer";
      config.headers["workcode"] =
        Vue.$ls.get("userInfo") && Vue.$ls.get("userInfo").workcode
          ? Vue.$ls.get("userInfo").workcode
          : "";
    }
    //添加追踪标识
    if (Vue.$ls.get("userInfo") && Vue.$ls.get("userInfo").workcode) {
      config.headers["Okr-Uid"] = Vue.$ls.get("userInfo").workcode;
    }
    //唯一性，无则生成
    if (localStorage.getItem("okr_cid")) {
      config.headers["Okr-Cid"] = localStorage.getItem("okr_cid");
    } else {
      const common_cid = "OKR_DING_" + creatUuid();
      config.headers["Okr-Cid"] = common_cid;
      localStorage.setItem("okr_cid", common_cid);
    }
    // config.headers["Okr-Cid"] = "OKR_PC_" + creatUuid();
    // if (config.method === "post" || config.method === "put") {
    //   config.data = qs.stringify(config.data);
    //   // 对post和put进行数据字符串化处理，若Content-Type:application/json则不需要
    //   config.headers["Content-Type"] = postHeaders;
    // }
    return config;
  },
  (error) => {
    // loadingInstance.close();
    Promise.reject(error);
  }
);

/**
 * axios respone拦截器
 * 首先针对特殊状态码特殊处理，提示内容统一在常量ts中更改
 * 采用element-ui弹框，根据业务对弹框形式自行改动
 */
http.interceptors.response.use(
  (config) => {
    return config.data || {};
  },
  (error: any) => {
    stopLoading();
    // * 网络超时处理
    if (error.message.includes("timeout")) {
      if (process.env.NODE_ENV == "development") {
        Notification({
          type: "error",
          title: HTTP_STATUS_TITLE_ERROR,
          message: "网络超时",
          duration: 6000,
        });
      }
      showToast("请求超时，请刷新重试", "error");
      return;
    }
    if (error == refreshErr) {
      // * 刷新中,忽略
      return;
    }
    // 登录失败|禁用|token失效等相关问题返回401，此处做跳转登录页动作

    if (error.response.status === 401) {
      if (!innerLock.isLocked()) {
        if (process.env.NODE_ENV == "development") {
          Notification({
            type: "error",
            title: HTTP_STATUS_TITLE_ERROR,
            message: error.response.data.message || HTTP_STATUS_MSG_401,
            duration: 6000,
          });
        }
        innerLock.lock();
        innerLock.autoUnlockLater();

        if (querys && querys.common_future == "weekly") {
          window.localStorage.setItem("common_future", "weekly");
        } else if (querys && querys.common_future == "okr") {
          window.localStorage.setItem("common_future", "okr");
        } else if (querys && querys.common_future == "daily") {
          window.localStorage.setItem("common_future", "daily");
        } else if (querys && querys.common_future == "forceRedirect") {
          window.localStorage.setItem("common_future", "forceRedirect");
          const url = new URL(window.location.href);
          // 获取url的query参数
          const queryParams = Object.fromEntries(url.searchParams);
          // 将url的pathname和query参数存储到localStorage中
          window.localStorage.setItem("urlInfo", JSON.stringify({path: url.pathname, query: queryParams}));
          
          showToast(locale("automatically_logging_in"));
        } else {
          showToast(locale("automatically_logging_in"));
        }
      }
      const common_future_value = localStorage.getItem("common_future");
      if (querys.search) {
        window.location.href = common_future_value
          ? `${
              COMMON_FUTURE_MAP_URL[common_future_value]
            }&${location.search.slice(1)}`
          : `${PATH_OKR_AUTHORIZATION}&${location.search.slice(1)}`;
      } else {
        window.location.href = common_future_value
          ? COMMON_FUTURE_MAP_URL[common_future_value]
          : PATH_OKR_AUTHORIZATION;
      }
    } else if (error.response.status === 429) {
      showToast("请求频繁，请稍后再试", "error");
      return Promise.reject(error.response);
    } else if (error.response.status === 422) {
      // console.log(error.response, "error");
      if (process.env.NODE_ENV == "development") {
        Notification({
          type: "error",
          title: HTTP_STATUS_TITLE_ERROR,
          message: error.response.data.message || HTTP_STATUS_TITLE_ERROR,
          duration: 6000,
        });
      }
      return Promise.resolve(error.response);
      // router.push({ path: PATH_LOGIN });
    } else if (error.response.status === 428) {
      // *没有数据权限
      if (!innerLock.isLocked()) {
        innerLock.lock();
        innerLock.autoUnlockLater();

        if (process.env.NODE_ENV == "development") {
          Notification({
            type: "error",
            title: HTTP_STATUS_TITLE_ERROR,
            message: error.response.data.message || HTTP_STATUS_MSG_401,
            duration: 6000,
          });
        }
        // 跳到list页面
        router.push({ path: PATH_HOME });
      }
    } else if (error.response.status === 403) {
      console.log("走到了403里");
      router.replace("/permission/no");
      return;
    } else if (
      error.response.status >= 400 &&
      error.response.status !== 422 &&
      error.response.status < 500
    ) {
      const type = error.response.status == 460 ? "info" : "error";
      const title =
        error.response.status == 460 ? "温馨提示" : HTTP_STATUS_TITLE_ERROR;
      if (process.env.NODE_ENV == "development") {
        Notification({
          type: type,
          title: title,
          message: error.response.data.message || HTTP_STATUS_TITLE_ERROR,
          duration: 6000,
        });
      }
      if (error.response.status !== 400) {
        showToast(error.response.data.message, "error");
      }
      return Promise.reject(error.response);
    } else {
      if (process.env.NODE_ENV == "development") {
        Notification({
          // 基于axiosCreate中validateStatus配置的区间判断此时状态码>=500 或者 浏览器直接报错(比如跨域) 走此弹框。
          type: "error",
          title: HTTP_STATUS_TITLE_5XX,
          message: HTTP_STATUS_MSG_5XX,
          duration: 6000,
        });
      }
      showToast(error.response.data.message, "error");
      // console.log(error, "******************");
      return Promise.reject(error.response);
      // Raven.captureException(error);
    }
  }
);

export default http;
